module.exports = __webpack_public_path__ + "static/media/i5.a0ae21ad.jpg";